// Libraries
import _ from 'lodash';

export interface Step {
  kind: string;
  title: string;
  description: string;
}

const API_KEY = 'API_KEY';
const ACCOUNT_AND_COMPANY = 'ACCOUNT_AND_COMPANY';
const PROJECT_SETTINGS = 'PROJECT_SETTINGS';
const EXCLUDED_PHONE_NUMBERS = 'EXCLUDED_PHONE_NUMBERS';
const REVIEW = 'REVIEW';

const EMPTY_STEP: Step = {
  kind: '',
  title: '',
  description: '',
};

const STEPS: Step[] = [
  {
    kind: API_KEY,
    title: 'API Key',
    description: 'Add the API key created in CallRail to import calls to Supermove.',
  },
  {
    kind: ACCOUNT_AND_COMPANY,
    title: 'Account & Company',
    description: 'Select the account and company applicable to your organization.',
  },
  {
    kind: PROJECT_SETTINGS,
    title: 'Project Settings',
    description: 'Configure project and job types',
  },
  {
    kind: EXCLUDED_PHONE_NUMBERS,
    title: 'Skip Call Creation',
    description:
      'Enter the phone numbers below that Copilot should ignore when creating calls — calls from these specific CallRail numbers will be skipped.',
  },
  {
    kind: REVIEW,
    title: 'Review',
    description: 'Before submitting, make sure this information is correct.',
  },
];

const getStep = (kind: string, steps: Step[] = STEPS): Step => {
  return _.find(steps, (step) => step.kind === kind) || EMPTY_STEP;
};

const getPreviousStep = (kind: string, steps: Step[] = STEPS): Step => {
  const index = _.findIndex(steps, (step) => step.kind === kind);
  const step = index <= 0 ? undefined : steps[index - 1];
  return step || EMPTY_STEP;
};

const getNextStep = (kind: string, steps: Step[] = STEPS): Step => {
  const index = _.findIndex(steps, (step) => step.kind === kind);
  const step = index < 0 || index >= STEPS.length - 1 ? undefined : steps[index + 1];
  return step || EMPTY_STEP;
};

const SetupCallrailIntegrationStep = {
  API_KEY,
  ACCOUNT_AND_COMPANY,
  PROJECT_SETTINGS,
  EXCLUDED_PHONE_NUMBERS,
  REVIEW,
  EMPTY_STEP,
  STEPS,
  getStep,
  getPreviousStep,
  getNextStep,

  // These functions are for current compatibility with useProgress
  getPreviousStepKind: (kind: string, steps?: Step[]) =>
    SetupCallrailIntegrationStep.getPreviousStep(kind, steps).kind,
  getNextStepKind: (kind: string, steps?: Step[]) =>
    SetupCallrailIntegrationStep.getNextStep(kind, steps).kind,
};

export default SetupCallrailIntegrationStep;
